module.exports = __webpack_public_path__ + "img/Health&Fitness.3b80dda2.jpg";